import React from 'react'

import moment from 'moment'

import DateArrow from './DateArrow'
import DateItem from './DateItem'
import TimePeriod from '../../common/date/TimePeriod'

const dateFormat = 'YYYY-MM-DD'

export default class DateView extends React.Component {

  constructor(props) {
    super(props)
    const startDate = moment(props.startDateStr)
    const endDate = moment(props.endDateStr)
    this.state = {
      startDate,
      endDate,
      rangeDays: endDate.diff(startDate, 'days') + 1,
      singleDay: props.singleDay,
      showTimePeriod: props.showTimePeriod
    }
  }

  componentWillReceiveProps(nextProps) {
    const startDate = moment(nextProps.startDateStr)
    const endDate = moment(nextProps.endDateStr)

    this.setState({
      startDate,
      endDate,
      rangeDays: endDate.diff(startDate, 'days') + 1,
      singleDay: nextProps.singleDay,
      showTimePeriod: nextProps.showTimePeriod
    })
  }

  onStartDateChange = date => {
    const startDate = this.state.startDate
    const endDate = this.state.endDate
    const diffDays = endDate.diff(startDate, 'days')

    const newStartDate = moment(date)
    const newEndDate = moment(newStartDate).add(diffDays, 'days')

    this.setState({
      startDate: newStartDate,
      endDate: newEndDate
    })
    this.props.onDateChange(
      newStartDate.format(dateFormat),
      newEndDate.format(dateFormat))
  }

  onEndDateChange = date => {
    const newEndDate = moment(date)
    const diffDays = newEndDate.diff(this.state.startDate, 'days')

    this.setState({
      rangeDays: diffDays,
      endDate: newEndDate
    })

    this.props.onDateChange(
      this.state.startDate.format(dateFormat),
      newEndDate.format(dateFormat))
  }

  handleChangePeriod = newPeriod => {

    const duration = TimePeriod.getSelectedPeriodDuration(newPeriod)
    const newEndDate = moment(this.state.startDate)
      .add(duration.asDays() - 1, 'days')
    
    this.setState({
      rangeDays: duration.asDays(),
      endDate: newEndDate
    })

    this.props.onDateChange(
      this.state.startDate.format(dateFormat),
      newEndDate.format(dateFormat))
  }

  onLeftPressed = () => {
    this.onStartDateChange(moment(this.state.startDate).subtract(this.state.rangeDays, 'days'))
  }

  onRightPressed = () => {
    this.onStartDateChange(moment(this.state.endDate).add(1, 'days'))
  }

  renderSingleDate() {
    return (
      <DateItem
        dateStr={this.state.startDate.format()}
        dateFormat={'ddd MMM, DD'}
        onDateChange={this.onStartDateChange}/>
    )
  }

  renderRangeDate() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <DateItem
          dateStr={this.state.startDate.format()}
          dateFormat={'ddd MMM, DD'}
          onDateChange={this.onStartDateChange} />
        <div>
          —
        </div>
        <DateItem
          dateStr={this.state.endDate.format()}
          dateFormat={'ddd MMM, DD'}
          onDateChange={this.onEndDateChange} />
      </div>
    )
  }

  renderWeekNumbers() {
    const startWeek = this.state.startDate.week()
    const endWeek = this.state.endDate.week()
    const text = startWeek === endWeek
      ? `Week ${startWeek}`
      : `Weeks ${startWeek} – ${endWeek}`
    return (
      <span
        style={{ fontSize: 14, marginLeft: 12, color: '#595b5f'}}>
        {text}
      </span>
    )
  }

  computeSelectedPeriod = () => {
    const diff = (this.state.endDate.diff(this.state.startDate, 'days') + 1) / 7
    return `${diff}w`
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', height: '36px', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', border: '1px solid #e2e2e2', backgroundColor: '#fafafa'}}>
          <div style={{ borderRight: '1px solid #e2e2e2' }}>
            <DateArrow
              direction={DateArrow.Direction.LEFT}
              onPress={this.onLeftPressed} />
          </div>
          {
            this.state.singleDay
              ? this.renderSingleDate()
              : this.renderRangeDate()
          }
          <div style={{ borderLeft: '1px solid #e2e2e2', marginLeft: 4 }}>
            <DateArrow
              direction={DateArrow.Direction.RIGHT}
              onPress={this.onRightPressed} />
          </div>
        </div>
        { this.state.showTimePeriod &&
          <TimePeriod
            selectedPeriod={this.computeSelectedPeriod()}
            onChangePeriod={this.handleChangePeriod} />
        }
        { this.state.showTimePeriod && this.renderWeekNumbers() }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/common/date/DateView.js